<template>
  <div v-loading="loading" class="radish-list">
    <div v-if="showSearch && searchReady" class="radish-search">
      <div v-if="isFull" v-show="searchMode == 'simple' || listEsEnabled" class="simple">
        <formItem
          v-if="searchFields['职能模块'] && searchMode == 'simple'"
          :key="searchFields['职能模块'].label"
          :type="searchFields['职能模块'].type"
          :is-inline="true"
          :width="searchFields['职能模块'].width"
          :label-width="searchFields['职能模块'].labelWidth"
          :label="searchFields['职能模块'].label"
          :display-label="searchFields['职能模块'].displayLabel"
          :options="searchFields['职能模块'].options"
          :content="searchData[searchFields['职能模块'].label]"
          :handle-data-change="handleSearchChange"
        ></formItem>
        <div class="form-item form-item-inline" style="width:300px;paddingLeft:60px">
          <label style="width: 60px">全文检索</label>
          <div class="el-input el-input--mini">
            <input
              v-model="keywords"
              type="text"
              autocomplete="off"
              placeholder="请输入关键词,多个关键词以空格空开"
              class="el-input__inner"
              @keyup.enter="handleSearch"
            />
          </div>
        </div>
        <el-button type="primary" size="mini" round @click="searchFieldsSelect">更改搜索字段</el-button>
        <el-checkbox v-model="searchCvContentEnable" style="margin-left: 10px;">搜索附件</el-checkbox>
        <el-checkbox v-model="andKeywordsStatus">匹配全部关键字</el-checkbox>
        <template v-if="searchMode == 'simple'">
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            size="mini"
            @click="
              () => {
                this.setMode('complete')
                if (!listEsEnabled) {
                  this.keywords = ''
                }
                this.searchEsEnable = false
              }
            "
            >展开</el-button
          >
          <el-button type="primary" size="mini" round @click="handleSearch">搜索</el-button>
          <el-button size="mini" round @click="cleanSearch">清空</el-button>
        </template>
      </div>
      <div v-else v-show="searchMode == 'simple'" class="simple">
        <template v-for="i in 4">
          <formItem
            v-if="searchFields[searchOrder[i - 1]]"
            :key="searchFields[searchOrder[i - 1]].label + 's'"
            :type="searchFields[searchOrder[i - 1]].type"
            :is-inline="true"
            :width="searchFields[searchOrder[i - 1]].width"
            :label-width="searchFields[searchOrder[i - 1]].labelWidth"
            :label="searchFields[searchOrder[i - 1]].label"
            :display-label="searchFields[searchOrder[i - 1]].displayLabel"
            :options="searchFields[searchOrder[i - 1]].options"
            :content="searchData[searchFields[searchOrder[i - 1]].label]"
            :handle-data-change="handleSearchChange"
            @keyup-enter.stop="handleSearch"
          ></formItem>
        </template>
        <el-button
          icon="el-icon-arrow-down"
          type="text"
          size="mini"
          @click="
            () => {
              this.setMode('complete')
              this.searchEsEnable = false
            }
          "
          >展开</el-button
        >
        <el-button type="primary" size="mini" round @click="handleSearch">搜索</el-button>
        <el-checkbox v-if="isFull" v-model="listEsEnabled" style="margin-left: 10px;">体验ES详情搜索</el-checkbox>
        <el-button size="mini" round @click="cleanSearch">清空</el-button>
        <el-button size="mini" round @click="saveCondition">保存搜索条件</el-button>
        <el-button size="mini" round @click="orderCondition">搜索项顺序</el-button>
      </div>
      <div v-show="searchMode == 'complete'" class="complete">
        <template v-for="f in searchOrder">
          <formItem
            v-if="searchFields[f]"
            :key="searchFields[f].label"
            :type="searchFields[f].type"
            :is-inline="true"
            :width="searchFields[f].width"
            :label-width="searchFields[f].labelWidth"
            :label="searchFields[f].label"
            :display-label="searchFields[f].displayLabel"
            :options="searchFields[f].options"
            :content="searchData[searchFields[f].label]"
            :handle-data-change="handleSearchChange"
            @keyup-enter.stop="handleSearch"
          ></formItem>
        </template>
        <div class="form-item" style="padding: 0 5px">
          <label style="margin-right:5px">沟通日志</label>
          <el-date-picker
            v-model="daterange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            size="mini"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-checkbox v-model="notRangeEnable" style="margin-left:10px">未沟通</el-checkbox>
        </div>
        <div class="form-item">
          <label>目标公司</label>
          <span :title="searchData['目标公司'] || ''"
            >（已选择{{ searchData['目标公司'] ? searchData['目标公司'].length : 0 }}家）</span
          >
          <el-button type="text" size="mini" @click="showTargetCompany">选择</el-button>
        </div>
        <div style="padding:5px">
          <el-button
            icon="el-icon-arrow-up"
            type="text"
            size="mini"
            @click="
              () => {
                this.setMode('simple')
                this.searchEsEnable = true
              }
            "
            >收起</el-button
          >
          <el-button type="primary" size="mini" round @click="handleSearch">搜索</el-button>
          <template v-if="searchMode == 'complete'">
            <el-checkbox v-if="isFull" v-model="listEsEnabled" style="margin-left: 10px;">体验ES详情搜索</el-checkbox>
            <el-button size="mini" round @click="cleanSearch">清空</el-button>
            <el-button size="mini" round @click="saveCondition">保存筛选条件</el-button>
            <el-button size="mini" round @click="orderCondition">搜索项顺序</el-button>
          </template>
        </div>
      </div>
    </div>
    <div ref="radishTableWapper">
      <a-table
        v-if="listMode === 'table'"
        ref="radishTable"
        :data="radishes"
        :heads="tableHeads"
        :height="tableHeight"
        :active-row-id="activeRowId"
        :storage-name="storageName"
        :start="limit * (page - 1)"
        :on-set-hidden-cell="setHiddenCell"
        :on-set-cell-order="setCellOrder"
      >
        <template slot="actions">
          <div class="radish-act-grp">
            <span v-if="defaultProject._id">当前项目【{{ defaultProject.label }}】</span>
            <el-tag v-if="fav && fav._id" effect="dark" closable size="small" @close="closeFav"
              >当前收藏夹【{{ fav.name }}】</el-tag
            >
            <template v-if="!defaultProject._id">
              批量：
              <div class="radish-btn radish-btn-primary" @click="showIntoProject(true)">加入项目</div>
              <div class="radish-btn radish-btn-primary" @click="showRecommend(true)">推荐</div>
              <div class="radish-btn radish-btn-primary" @click="del">删除</div>
              <div class="radish-btn radish-btn-primary" @click="showEditDialog">修改字段内容</div>
              <div v-if="departments" class="radish-btn radish-btn-primary" @click="showEditDepartment">修改部门</div>
              <div class="radish-btn radish-btn-primary" @click="showCateDialog('添加')">添加职能模块</div>
              <div class="radish-btn radish-btn-primary" @click="showCateDialog('删除')">删除职能模块</div>
              <div v-if="fav && fav._id" class="radish-btn radish-btn-primary" @click="outFavorite">移出收藏夹</div>
              <div v-else class="radish-btn radish-btn-primary" @click="addToFavorite">加入收藏夹</div>
              <div v-if="isAdmin" class="radish-btn radish-btn-primary" @click="testMatch">匹配测试</div>
            </template>
          </div>
          <template>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <el-radio-group v-model="ccSearch" size="mini">
                <el-radio-button label="all">所有</el-radio-button>
                <el-radio-button label="nocc">不看cc</el-radio-button>
                <el-radio-button label="cc">只看cc</el-radio-button>
              </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <el-radio-group v-model="progressSearch" size="mini">
                <el-radio-button label="all">所有</el-radio-button>
                <el-radio-button label="noop">不看到岗</el-radio-button>
                <el-radio-button label="op">只看到岗</el-radio-button>
              </el-radio-group>
            </div>
          </template>
          &nbsp;&nbsp;
          <div v-if="isFull" class="radish-act-grp">
            <el-radio-group v-model="listMode" size="mini">
              <el-radio-button label="table"> <i class="el-icon-s-grid"></i> </el-radio-button>
              <el-radio-button label="list"> <i class="el-icon-notebook-2"></i> </el-radio-button>
            </el-radio-group>
          </div>
          <slot name="btns"></slot>
        </template>
      </a-table>
      <a-list
        v-else-if="listMode === 'list'"
        ref="radishTable"
        :data="radishes"
        :height="tableHeight"
        :start="limit * (page - 1)"
        :on-click-name="clickName"
        :on-click-company="clickCompany"
        :on-click-setting="showAction"
        :on-click-document="showFiles"
        :on-into-project="showIntoProject"
        :on-upload-cv="uploadCv"
        :on-click-status="clickStatus"
      >
        <template slot="actions">
          <div class="radish-act-grp">
            批量： <span v-if="defaultProject._id">当前项目【{{ defaultProject.label }}】</span>
            <span v-if="fav && fav._id">当前收藏夹【{{ fav.name }}】</span>
            <div class="radish-btn radish-btn-primary" @click="showIntoProject(true)">加入项目</div>
            <div class="radish-btn radish-btn-primary" @click="showRecommend(true)">推荐</div>
            <div class="radish-btn radish-btn-primary" @click="del">删除</div>
            <div class="radish-btn radish-btn-primary" @click="showEditDialog">修改字段内容</div>
            <div v-if="departments" class="radish-btn radish-btn-primary" @click="showEditDepartment">修改部门</div>
            <div class="radish-btn radish-btn-primary" @click="showCateDialog('添加')">添加职能模块</div>
            <div class="radish-btn radish-btn-primary" @click="showCateDialog('删除')">删除职能模块</div>
            <div v-if="fav && fav._id" class="radish-btn radish-btn-primary" @click="outFavorite">移出收藏夹</div>
            <div v-else class="radish-btn radish-btn-primary" @click="addToFavorite">加入收藏夹</div>
            <div v-if="isAdmin" class="radish-btn radish-btn-primary" @click="testMatch">匹配测试</div>
          </div>
          <template>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <el-radio-group v-model="ccSearch" size="mini">
                <el-radio-button label="all">所有</el-radio-button>
                <el-radio-button label="nocc">不看cc</el-radio-button>
                <el-radio-button label="cc">只看cc</el-radio-button>
              </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <el-radio-group v-model="progressSearch" size="mini">
                <el-radio-button label="all">所有</el-radio-button>
                <el-radio-button label="noop">不看到岗</el-radio-button>
                <el-radio-button label="op">只看到岗</el-radio-button>
              </el-radio-group>
            </div>
          </template>
          &nbsp;&nbsp;
          <div v-if="isFull" class="radish-act-grp">
            <el-radio-group v-model="listMode" size="mini">
              <el-radio-button label="table"> <i class="el-icon-s-grid"></i> </el-radio-button>
              <el-radio-button label="list"> <i class="el-icon-notebook-2"></i> </el-radio-button>
            </el-radio-group>
          </div>
          <slot name="btns"></slot>
        </template>
      </a-list>
    </div>
    <div class="radish-page">
      <el-pagination
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <Popper id="radish-popper" :visible.sync="popperVisible" :target-id="popperTarget">
      <div class="radish-pop">
        <AttachmentsType
          v-if="popperContent == 'files'"
          :attach="files"
          :rid="popperTarget && popperTarget.replace('附件', '')"
          :paginate="false"
          :on-delete="deleteAttachment"
          :width="600"
          :height="300"
        />
        <span v-if="popperContent == 'action'">
          <el-button size="mini" @click="showIntoProject(false)">加入项目</el-button>
          <el-button v-if="currentRow['手机']" size="mini" @click="showRecommend(false)">推荐</el-button>
          <el-button size="mini" @click="uploadCv()">上传简历</el-button>
          <el-button size="mini" @click="uploadReport()">上传推荐报告</el-button>
          <el-button size="mini" @click="genRepo">生成推荐报告</el-button>
          <el-button size="mini" @click="showRadishPortrait">人才画像</el-button>
        </span>
        <div v-if="popperContent == 'bulletin'">
          <el-table :data="bulletins" border size="mini" :resizable="false" style="width: 600px; height: 200px">
            <el-table-column
              v-for="head in bulletinHeads"
              :key="head.label"
              :prop="head.label"
              :label="head.label"
              :width="head.width"
            ></el-table-column>
          </el-table>
        </div>
        <workExp
          v-if="popperContent == 'comExp'"
          ref="workExp"
          :radish="currentRow"
          :on-close="onCloseWorkexp"
        ></workExp>
      </div>
    </Popper>
    <conditionDialog ref="conditionDialog"></conditionDialog>
    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
    <explainDialog ref="explainDialog" :on-confirm="loadData"></explainDialog>
    <departmentDialog ref="departmentDialog" :on-confirm="loadData"></departmentDialog>
    <UploadDialog ref="UploadDialog" :type="uploadType" :label="attachType" :on-success="uploadSuccess"></UploadDialog>
    <cellsDialog
      ref="searchFieldsDialog"
      :on-confirm="onSearchFieldsConfirm"
      storage-name="esSearchFields"
      title="筛选条件"
      with-check-all
    />
    <interviewListDialog ref="interviewListDialog"></interviewListDialog>
  </div>
</template>
<script>
import { Popper } from '../../project'
import conditionDialog from './dialog/condition-dialog'
import editDialog from './dialog/edit-dialog'
import cateDialog from './dialog/cate-dialog'
import explainDialog from './dialog/explain-dialog'
import departmentDialog from './dialog/department-dialog'
import { FileTable, UploadDialog } from '../../file'
import { searchFields } from './constant/fields-list'
import { fieldsEs } from './constant/fields-add'
import tableHeads from './constant/table-heads'
import bulletinHeads from './constant/bulletin-heads'
import methodsList from './constant/methods-list'
import pickerOptions from './constant/picker-options'
import aList from './table/a-list'
import workExp from './components/work-exp'
import cellsDialog from './table/cells-dialog'
import interviewListDialog from './dialog/interviewlist-dialog'
import AttachmentsType from './components/attachments-type'
import TemplateDialog from '../../company/src/NewAddCompany/TemplateDialog.vue'

const dateFormat = require('dateformat')

export default {
  components: {
    aList,
    FileTable,
    conditionDialog,
    editDialog,
    cateDialog,
    explainDialog,
    UploadDialog,
    departmentDialog,
    workExp,
    Popper,
    cellsDialog,
    interviewListDialog,
    AttachmentsType,
  },
  mixins: [tableHeads, bulletinHeads, methodsList],
  props: {
    company: String,
    department: String,
    group: String,
    departments: Array,
    pid: String,
    showSearch: {
      type: Boolean,
      default: true,
    },
    isFull: Boolean,
    type: String,
    fav: Object,
    ids: Array,
    onkeyMatchMode: String,
    onConfirm: Function,
    onkeyMatchMode: String,
  },
  data: function() {
    return {
      loading: false,
      searchReady: false,
      catData: [],
      radishes: [],
      query: {},
      total: 0,
      page: 1,
      pageSizes: [50, 100, 200, 300],
      limit: 300,
      multipleSelection: [],
      searchFields: searchFields,
      searchOrder: [],
      searchData: { 工作年限: [0, 30] },
      searchMode: 'complete',
      yiOptions: ['Y', 'N', 'F'],
      defaultProject: {},
      tableHeight: 600,
      ccSearch: 'all',
      progressSearch: 'all',
      filesVisible: false,
      actionVisible: false,
      files: [],
      currentRow: {},
      popperVisible: false,
      popperContent: '',
      popperTarget: '',
      storageName: 'radishHeads',
      attachType: '',
      uploadType: '',
      bulletins: [],
      daterange: '',
      pickerOptions: pickerOptions,
      testMatchIds: [],
      keywords: '',
      searchEsEnable: true,
      searchCvContentEnable: true,
      listMode: 'table',
      listEsEnabled: true,
      andKeywordsStatus: false,
      notRangeEnable: false,
    }
  },
  computed: {
    isAdmin() {
      return app.user['角色'] && app.user['角色'].includes('管理员')
    },
    activeRowId() {
      return this.currentRow._id
    },
  },
  watch: {
    company: function() {
      this.setDefault()
    },
    department: function() {
      this.setDefault()
    },
    group: function() {
      this.setDefault()
    },
    pid: function() {
      this.setDefault()
    },
    ccSearch: function(newVal, oldVal) {
      switch (newVal) {
        case 'nocc':
          this.query['手机'] = '非空'
          break
        case 'cc':
          this.query['手机'] = '空'
          break
        default:
          this.query['手机'] = ''
          break
      }
      this.setDefault()
    },
    progressSearch: function(newVal, oldVal) {
      switch (newVal) {
        case 'noop':
          this.query.progress = '空'
          break
        case 'op':
          this.query.progress = '非空'
          break
        default:
          this.query.progress = ''
          break
      }
      this.setDefault()
    },
    listMode: function() {
      this.setDefault()
    },
    currentFav: function() {
      this.setDefault()
    },
    ids: function(newVal, oldVal) {
      if (newVal) {
        this.setDefault()
      }
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.resetTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resetTableHeight)
  },
  mounted: async function() {
    if (app.name === 'syn') {
      this.searchFields.谷露行业 = {
        label: '谷露行业',
        width: '200px',
      }
      this.searchFields.谷露职能 = {
        label: '谷露职能',
        width: '200px',
      }
      if (this.tableHeads[2].label !== '谷露行业') {
        const gulu1 = {
          label: '谷露行业',
          field: '谷露行业',
          type: 'tag',
          width: 100,
        }
        const gulu2 = {
          label: '谷露职能',
          field: '谷露职能',
          type: 'tag',
          width: 100,
        }
        this.tableHeads.splice(2, 0, gulu1, gulu2)
      }
    }
    await this.loadCate()
    if (localStorage.search_sort) {
      this.searchOrder = Object.keys(JSON.parse(localStorage.search_sort))
      for (const field in this.searchFields) {
        if (!this.searchOrder.includes(field)) {
          this.searchOrder.push(field)
        }
      }
    } else {
      this.searchOrder = Object.keys(this.searchFields)
    }
    if (localStorage.radishEsKeywords) {
      this.keywords = localStorage.radishEsKeywords
    }
    if (localStorage.andKeywordsStatus) {
      this.andKeywordsStatus = localStorage.andKeywordsStatus == 'on'
    }
    if (localStorage.searchCvContentEnable) {
      this.searchCvContentEnable = localStorage.searchCvContentEnable == 'on'
    }
    this.searchReady = true
    // console.log(this.searchOrder)
    this.setHiddenCell('donotLoadData')
    this.setCellOrder()
    if (localStorage.radishSearchData && this.isFull) {
      // console.log(localStorage.radishSearchData)
      this.searchData = JSON.parse(localStorage.radishSearchData)
      this.handleSearch()
    } else {
      this.setDefault()
    }
    this.$nextTick(() => {
      this.resetTableHeight()
    })
  },
  methods: {
    loadData: async function() {
      // let start = Date.now()
      this.loading = true
      let res = {}
      const query = this.mapQuery()
      if (this.progressSearch === 'noop') {
        query.progress = '空'
      } else if (this.progressSearch === 'op') {
        query.progress = '非空'
      } else {
        delete query.progress
      }
      // const query = JSON.parse(JSON.stringify(this.query))
      // if (query.工作年限 && query.工作年限[0] == 0 && query.工作年限[1] == 30) delete query.工作年限
      const postData = {
        query: query,
        $page: this.page,
        $limit: this.limit,
        $sort: {
          公司排名: 1,
          公司: -1,
          部门: -1,
          职级: 1,
          createdAt: -1,
        },
      }
      if ((this.searchEsEnable && this.keywords) || this.listEsEnabled) {
        this.loading = true
        const savedHeadsStr = localStorage.esSearchFields
        let fields = []
        if (!savedHeadsStr) {
          fields = this.searchCvContentEnable ? ['_all'] : fieldsEs.map(head => head.field)
        }

        if (savedHeadsStr) {
          const savedHeads = JSON.parse(savedHeadsStr)
          if (Object.keys(savedHeads).every(k => savedHeads[k]) && this.searchCvContentEnable) {
            fields.push('_all')
          } else {
            fields = Object.keys(savedHeads).filter(k => savedHeads[k])
            const schoolIndex = fields.indexOf('学校')
            if (schoolIndex >= 0) {
              fields.splice(schoolIndex, 1, '*院校')
            }
            if (this.searchCvContentEnable) {
              fields.push('cvContent')
            }
          }
        }
        const esConditions = {
          type: '人选',
          keywords: this.keywords,
          and: this.andKeywordsStatus,
          $page: this.page,
          $limit: this.limit,
          fields,
          $sort: {
            公司排名: 1,
            公司: -1,
            部门: -1,
            职级: 1,
            createdAt: -1,
          },
          query,
        }
        try {
          await app.service('project').saveRecords({
            type: '人选es搜索',
            path: '条件搜索',
            page: '人才',
            data: { 搜索条件: { query, and: this.andKeywordsStatus, keywords: this.keywords, fields } },
          })
        } catch (error) {
          console.error(error.message)
        }
        // 沟通日志范围
        if (this.daterange) {
          res = await app.service('radish').getRadishByRemarkDate({
            daterange: this.daterange,
            data: esConditions,
            type: 'listEs',
            isNot: this.notRangeEnable,
          })
        } else {
          res = await app.service('radish').listEs(esConditions)
        }
      } else {
        let fields = {}
        if (this.listMode === 'list') {
          fields = { _id: 1 }
        } else {
          fields['手机'] = 1
          fields['公司排名'] = 1
          fields.progress = 1
          fields.status = 1
          fields.thirdId = 1
          this.tableHeads.forEach(head => {
            if (!head.hidden) {
              if (head.field) {
                fields[head.field] = 1
              } else {
                fields[head.label] = 1
              }
            }
          })
        }
        postData.$fields = fields
        try {
          await app
            .service('project')
            .saveRecords({ type: '人选数据库搜索', path: '条件搜索', page: '人才', data: { 搜索条件: { query } } })
        } catch (error) {
          console.error(error.message)
        }
        // 沟通日志范围
        if (this.daterange) {
          res = await app.service('radish').getRadishByRemarkDate({
            daterange: this.daterange,
            data: postData,
            type: 'list',
            isNot: this.notRangeEnable,
          })
        } else {
          res = await app.service('radish').list(postData)
        }
      }
      if (res.status === 'success') {
        if (res.data.total) this.total = res.data.total
        if (this.listMode === 'list') {
          const rids = res.data.data.map(r => r._id)
          res = await app.service('radish').listMore({ ids: rids })
        }
        if (this.type === 'recommend' && this.ids) {
          const orderedRadish = []
          const idsObj = {}
          this.ids.forEach(idObj => {
            idsObj[idObj.id] = idObj.score
          })
          res.data.data = res.data.data.map(radishObj => {
            radishObj.score = idsObj[radishObj._id]
            return radishObj
          })
          res.data.data.sort((a, b) => {
            if (a.score > b.score) {
              return -1
            } else {
              return 1
            }
          })
          if (this.tableHeads[0].label !== '相关度') {
            this.tableHeads.unshift({
              label: '相关度',
              field: 'score',
              type: 'link',
              width: 60,
              handleContent: value => (value * 100).toFixed(3),
              onClick: async item => {
                // const result = {
                //   recommendReason: {
                //     person: { _id: 'B1--SAsO5S7', 姓名: '胡传禄' },
                //     project: { _id: 'B10RlGLm6DIm', 客户公司: '开源证券', 项目名称: '承做岗' },
                //     relatedProjs: [
                //       { _id: 'B1-FHQoMN', 客户公司: '上汽投资', 项目名称: '固收投资经理' },
                //       { _id: 'B107m2CzV', 客户公司: '新希望集团', 项目名称: '研究总监（二级）' },
                //     ],
                //     relatedPersons: [{ _id: 'B1--zQRAkR77', 姓名: '郭琪' }, { _id: 'B1-0Qlin50jIX', 姓名: '刘伟世' }],
                //   },
                // }
                const result = await app.service('project').explain({ pid: this.pid, rid: item._id })
                if (result.recommendReason) {
                  this.$refs.explainDialog.show(result.recommendReason)
                }
              },
            })
          }
        }
        this.radishes = res.data.data
        // console.log(this.radishes);
        this.$nextTick(function() {
          this.$refs.radishTable.setDisplay(true)
          localStorage.radishEsKeywords = ''
        })
        this.$emit('onLoaded', this.radishes)
      } else {
        console.error(res)
      }
      // let end = Date.now()
      this.loading = false
      if (!this.daterange && !this.listEsEnabled && app.service('radish').getRadishNum) {
        const numRes = await app.service('radish').getRadishNum(postData)
        this.total = numRes.data.total
      }
    },
    mapQuery: function() {
      const query = JSON.parse(JSON.stringify(this.query))
      if (query.工作年限 && query.工作年限[0] == 0 && query.工作年限[1] == 30) delete query.工作年限
      if (query.离职意愿度 && query.离职意愿度.length > 0) {
        const lizhiMap = { 观望不拒绝机会: 55, 有机会会动: 75, 离职动机强: 95 }
        query.离职意愿度 = query.离职意愿度.map(v => lizhiMap[v])
      }
      return query
    },
    loadOne: async function(id) {
      let res
      if (this.listMode == 'list') {
        res = await app.service('radish').listMore({ ids: [id] })
      } else {
        res = await app.service('radish').fetch({ _id: id })
      }
      if (res.status == 'success') {
        let dt
        if (this.listMode == 'list') {
          dt = res.data.data[0]
        } else {
          dt = res.data[0]
        }
        this.radishes = this.radishes.map(rad => {
          if (rad._id == id) {
            rad = dt
          }
          return rad
        })
        // console.log(dt)
        this.$nextTick(() => {
          this.$refs.radishTable.setDisplay(true)
        })
      }
    },
    getPhone: async function(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 手机: 1 } })
      if (res.status == 'success') {
        this.radishes.forEach(rad => {
          if (rad._id == id) {
            rad.手机 = res.data.手机
          }
        })
        // this.$nextTick(() => {
        //   this.$refs.radishTable.setDisplay(true)
        // })
      }
    },
    getGou: async function(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 沟通日志: 1 } })
      if (res.status == 'success') {
        this.radishes.forEach(rad => {
          if (rad._id == id) {
            rad.沟通日志 = res.data.沟通日志
          }
        })
        // this.$nextTick(() => {
        //   this.$refs.radishTable.setDisplay(true)
        // })
      }
    },
    handleSizeChange: function(val) {
      this.limit = val
      this.loadData()
    },
    handleCurrentChange: function(val) {
      this.page = val
      this.loadData()
    },
    handleSelectionChange: function(val) {
      // console.log(val)
      this.multipleSelection = val
    },
    handleSearchChange: function(res) {
      const { label, content } = res
      this.searchData[label] = content
      if (label == '职能模块') {
        this.searchReady = false
        const currentCat = this.catData.filter(cat => cat['名称'] == content)
        if (currentCat.length > 0) {
          const cat = currentCat[0]
          if (cat['二级职能'] && cat['二级职能'].length > 0) {
            const znArr = cat['二级职能']
            this.searchFields['细分职能'].options = znArr.concat('空')
          } else {
            this.searchFields['细分职能'].options = []
          }
          if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
            const scArr = cat['擅长方向']
            this.searchFields['擅长方向'].options = scArr.concat('空')
          } else {
            this.searchFields['擅长方向'].options = []
          }
        } else {
          this.searchFields['细分职能'].options = []
          this.searchFields['擅长方向'].options = []
        }
        this.searchFields['专业职级'].options = content && content.includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        this.searchReady = true
      }
    },
    handleSearch: async function() {
      const sdtStr = JSON.stringify(this.searchData)
      const sdt = JSON.parse(sdtStr)
      // console.log(sdt)
      const query = {}
      if (this.query['手机'] == '空' || this.query['手机'] == '非空') {
        query['手机'] = this.query['手机']
      }
      for (const field in sdt) {
        const val = sdt[field]
        if (val && val.length > 0) {
          query[field] = val
        }
      }

      this.query = query
      this.setDefQuery()
      if (this.type == 'radish') {
        delete this.query._id
      }
      console.log('q', query)
      this.page = 1
      await this.loadData()
      localStorage.radishSearchData = sdtStr
    },
    cleanSearch: function() {
      this.searchReady = false
      // console.log('clean1',this.searchData)
      this.searchData = { 工作年限: [0, 30] }
      this.daterange = ''
      this.keywords = ''
      this.handleSearch()
      // console.log('clean',this.searchData)
      this.searchReady = true
      localStorage.removeItem('radishSearchData')
    },
    onCloseWorkexp: function() {
      this.popperVisible = false
    },
    testMatch: async function() {
      await app.service('project').saveRecords({ type: '批量智能匹配测试', path: '条件搜索', page: '人才' })
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const ids = rows.map(r => r._id)
      this.testMatchIds = ids
      this.$nextTick(() => {
        this.$refs.testMatchForm.submit()
      })
    },
    async showRadishPortrait() {
      await app.service('project').saveRecords({ type: '人才画像', path: '条件搜索', page: '人才' })
      app.root.$refs.RadishPortrait.open({ rid: this.currentRow._id })
    },

    searchFieldsSelect() {
      const savedHeadsStr = localStorage.esSearchFields
      let heads
      if (savedHeadsStr) {
        const savedHeads = JSON.parse(savedHeadsStr)
        heads = fieldsEs.map(head => ({ label: head.label, visible: savedHeads[head.label] }))
        // this.$refs.searchFieldsDialog.checkAll = Object.keys(savedHeads).every(h => savedHeads[h])
      } else {
        heads = fieldsEs.map(head => ({ label: head.label, visible: true }))
      }
      this.$refs.searchFieldsDialog.show(heads)
    },

    onSearchFieldsConfirm() {
      console.info('esSearchSelect')
    },
    clickStatus: function(item) {
      this.$refs.interviewListDialog.show(item)
    },
    closeFav() {
      this.$parent.setCurrentFav({})
    },
  },
}
</script>
